import { render } from "./QualificationLanguage.vue?vue&type=template&id=9705a6e2"
import script from "./QualificationLanguage.vue?vue&type=script&lang=js"
export * from "./QualificationLanguage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__